import { useState } from "react";
import Backdrop from "../../layouts/Backdrop";
import EditProfile from "./EditProfile";
import ProfileImage from "./ProfileImage";
import useAuth from "../../hooks/useAuth";

const ProfileHeader = () => {
  const { profile_image, user } = useAuth();
  const [openBackdrop, setOpenBackdrop] = useState(false);

  const toggleBackdrop = () => {
    setOpenBackdrop((prev) => !prev);
  };

  return (
    <>
      <div className="pt-5">
        <div className="w-full md:w-646 p-5 m-auto">
          <div
            key={Math.random()}
            className="flex flex-col md:flex-row gap-2 md:gap-10"
          >
            <div className="m-auto md:m-0">

            <ProfileImage
              widthSm="w-20"
              heightSm="h-20"
              widthMd="md:w-150"
              heightMd="md:h-150"
              leadingMd="md:leading-150"
              leadingSm="leading-20"
              profile_image={profile_image || null}
              store_name={user.data?.first_name}
            />
          </div>

            <div>
              <div className="block md:flex gap-8 items-center">
                <h4 className="font-normal text-center md:text-start text-lg md:text-2xl">{`${user.data.first_name}'s Thrift`}</h4>
                <div className="flex justify-center md:justify-start items-center gap-5 mt-2 md:mt-0">
                  <button
                    onClick={toggleBackdrop}
                    className="border border-label font-bold w-28 rounded-3xl h-8"
                  >
                    Edit Profile
                  </button>
                  <button className="w-8 h-8 border border-label flex items-center justify-center rounded-3xl ">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-gear"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z" />
                      <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z" />
                    </svg>
                  </button>
                </div>
              </div>
              <p className=" mt-2 text-center md:text-start">
                Phone number:{"  "}
                <span className="font-bold">{user.data?.phone_number}</span>
              </p>
              <p className="mt-2 text-center md:text-start">
                Email: {"  "}
                <span className="font-bold">{user.data?.email}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <Backdrop
        openBackdrop={openBackdrop}
        component={
          <EditProfile
            profile_image={profile_image || null}
            store_name={user.data?.first_name}
            phone={user.data?.phone_number}
            toggleBackdrop={toggleBackdrop}
          />
        }
      />
    </>
  );
};

export default ProfileHeader;
